import { render, staticRenderFns } from "./CancellationPolicyCategory.vue?vue&type=template&id=0cb0e740&scoped=true&"
import script from "./CancellationPolicyCategory.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicyCategory.vue?vue&type=script&lang=js&"
import style0 from "./CancellationPolicyCategory.vue?vue&type=style&index=0&id=0cb0e740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0e740",
  null
  
)

export default component.exports